<template>
  <div id="app">
    <div v-if="this.$route.path !== '/' && this.$route.path !== '/login' && this.$store.state && this.$store.state.user">
      <side-menu></side-menu>
    </div>
    <div id="router-view">
      <router-view></router-view>
    </div>
    <modal name="loading-general">
      <loading :info="{}" ref="l_gen_m"></loading>
    </modal>
  </div>
</template>

<script>
let $ = require('jquery')
import Modal from 'reusable/Modal'
import Loading from 'components/Modals/Loading'
import SideMenu from 'persistant/Menu'
export default {
  name: 'app',
  methods: {
    setModalInfo(info) {
      this.$refs.l_gen_m.setInfo(info)
    },
    closeModal() {
      $('#loading-general-modal #dismiss-button').click()
      // $('#loading-general-modal #dismiss-button').on('click', 'button', () => {
      // })
    }
  },
  components: {
    SideMenu,
    Modal,
    Loading
  }
}
</script>

<style lang="scss">
#app {

}

html{
  background-color:black;
}

#router-view{
  margin-left: 50px;
}

</style>




// WEBPACK FOOTER //
// App.vue?61a2828a